"use client";

import React from "react";
import { Link } from "@/components/common/Link";
export default function BrandFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="brand-footer" className="dark bg-background text-foreground py-12 px-8 border-t border-border">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        {}
        <div className="flex flex-col items-center md:items-start gap-4 order-2 md:order-1">
          <p className="text-sm text-muted-foreground">© 2026 JW IINSPECTIONS</p>
          <nav className="flex flex-col gap-2 items-center md:items-start">
            <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </nav>
        </div>

        {}
        <div className="flex justify-center order-1 md:order-2 mb-6 md:mb-0">
          <img src="https://joewestinspections.com/wp-content/uploads/2026/03/Screenshot-2026-03-06-at-10.21.27-AM.png" alt="JW CONSTRUCTION Logo" className="opacity-90 !h-[40px]" />
        </div>

        {}
        <div className="flex items-center justify-center md:justify-end gap-3 order-3">
          
          
        </div>
      </div>
    </section>;
}